<template>
  <v-dialog v-model="showModal" max-width="500px" persistent>
    <v-card>
      <v-toolbar dark class="primary">
        <v-btn icon @click.native="showModal = false" dark>
          <v-icon>fa-times</v-icon>
        </v-btn>
        <v-toolbar-title>{{title}}</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
        <v-form @submit="handleSubmit" v-model="valid" lazy-validation ref="form">
          <v-container  grid-list-xl>
            <v-row row wrap>
              <v-col cols="12">
                <v-text-field label="Nazwa"  v-model="name" :rules="[name.required, name.min_length]"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field label="Adres 1" v-model="address_line1" :rules="[address_line1_rules.required]"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field label="Adres 2" v-model="address_line2" ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field label="Kod pocztowy" v-model="postcode" ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field label="Miasto" v-model="city" :rules="[city_rules.required]"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-checkbox label="Czy aktywna?" v-model="isactive"></v-checkbox>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="closeForm" color="error">Zamknij</v-btn>
        <v-btn color="success"   @click="handleSubmit">Zapisz</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import swal from "sweetalert";
import {settingsService} from "@/services";
export default {
  name: "AddEditAddtionalOutposts",
  data() {
    return {
      title: "Dodawanie dodatkowej placówki",
      loading: false,
      valid: true,
      name: '',
      city: '',
      address_line1: '',
      address_line2: '',
      postcode: '',
      isactive: true,
      name_rules: {
        required: value=> !!value || 'Nazwa jest wymagana',
        min_length: value=> !(value && value.length < 3) || 'Nazwa musi posiadać minimum 3 znaki'
      },
      city_rules: {
        required: value=> !!value || 'Miasto jest wymagane'
      },
      address_line1_rules: {
        required: value=> !!value || 'Adres jest wymagany'
      }
    };
  },
  props: ["outpost","visible","settingsid"],
  methods: {
    showError(close, text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(() => {
        this.loading = false;
        if (close) {
          this.$emit("close");
        }
      });
    },
    closeForm() {
      this.$emit("close");
    },
    handleSubmit() {
      if(this.$refs.form.validate()) {
        let data = {
            companySettingsId: this.settingsid,
            id: this.outpost != null ? this.outpost.id : 0,
            name: this.name,
            city: this.city,
            addressLine1: this.address_line1,
            addressLine2: this.address_line2,
            postcode: this.postcode,
            isActive: this.isactive
        }

        if(this.outpost == null)
        {
          settingsService.insertAdditionalOutpost(data).then(() => {
            this.$emit('close')
          }).catch(() => {
            this.showError(false, 'Błąd zapisu dodatkowej placówki')
          })
        }
        else
        {
          settingsService.updateAdditionalOutpost(data).then(() => {
            this.$emit('close')
          }).catch(() => {
            this.showError(false, 'Błąd zapisu dodatkowej placówki')
          })
        }
      }
    },
    hide() {
      this.visibility_class = 'row scale-transition scale-out'
      this.loading = true
    },
    show() {
      this.visibility_class = 'row'
      this.loading = false
    },
  },
  computed: {
    showModal: {
      get: function() {
        return this.visible
      },
      set: function(value) {
        if(!value){
          this.$emit('close')
        }

      }
    }
  },
  watch: {
    outpost: {
      immediate: true,
      handler(newval) {
        if(newval == null)
        {
          this.title = 'Dodawanie nowej placówki'
        }
        else
        {
          this.name = newval.name
          this.city = newval.city
          this.address_line1 = newval.addressLine1
          this.address_line2 = newval.addressLine2
          this.postcode = newval.postcode
          this.isactive = newval.isActive
          this.title = 'Edycja placówki'
        }
      }
    },
  },
};
</script>

<style>

</style>
